import { Button } from 'components/button/Button/Button'
import React, { useState } from 'react'
import { StyledDialogFooter } from './style'
import { useDialogContext } from '../controller/DialogProvider'
import { Icons } from 'contents/icons'
import { useDialogOverlayContext } from '../controller/DialogOverlay'

interface DialogFooterProps {
  button?: {
    label?: string
    preIcon?: keyof typeof Icons
    postIcon?: keyof typeof Icons
    disabled?: boolean
    width?: string
    offAutoClose?: boolean
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => Promise<boolean> | void
  }
  secondButton?: {
    label?: string
    preIcon?: keyof typeof Icons
    postIcon?: keyof typeof Icons
    disabled?: boolean
    width?: string
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => Promise<boolean> | void
  }
  divider?: boolean
}

export const DialogFooter = ({ button, secondButton, divider = false }: DialogFooterProps) => {
  const { closeDialog } = useDialogContext()
  const { $size } = useDialogOverlayContext()

  /** 중복 제출 방지용 state */
  const [primarySubmitting, setPrimarySubmitting] = useState(false)
  const [secondarySubmitting, setSecondarySubmitting] = useState(false)

  return (
    <StyledDialogFooter $divider={divider}>
      {secondButton && (
        <Button
          color="primary"
          type="outline"
          width={secondButton.width ? secondButton.width : $size === 'small' ? '8rem' : '12rem'}
          size={$size === 'small' ? 'medium' : 'large'}
          label={secondButton.label}
          disabled={secondButton.disabled || secondarySubmitting}
          onClick={async (e) => {
            if (secondarySubmitting) return

            setSecondarySubmitting(true)

            try {
              const breakClose = secondButton.onClick && (await secondButton.onClick(e))

              if (breakClose) return

              closeDialog()
            } finally {
              setTimeout(() => {
                setSecondarySubmitting(false)
              }, 300)
            }
          }}
        />
      )}
      {button && (
        <Button
          color="primary"
          type="solid"
          sx={{ minWidth: button.width ? button.width : $size === 'small' ? '8rem' : '12rem' }}
          size={$size === 'small' ? 'medium' : 'large'}
          label={button.label}
          disabled={button.disabled || primarySubmitting}
          onClick={async (e) => {
            if (primarySubmitting) return

            setPrimarySubmitting(true)

            try {
              const breakClose =
                (button.onClick && (await button.onClick(e))) || button.offAutoClose

              if (breakClose) return

              closeDialog()
            } finally {
              // dialog 닫히는 시점까지 대기 (DialogProvider의 closeDialog 함수 내부에서 300ms 대기 후 닫힘)
              setTimeout(() => {
                setPrimarySubmitting(false)
              }, 300)
            }
          }}
        />
      )}
    </StyledDialogFooter>
  )
}
